import { DEFAULT_ANIMATE_DURATION, noForwardProps } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import ApeironScrollBox from '@src/components/share/apeiron/ApeironScrollBox'
import * as R from 'ramda'
import {
  FC,
  ReactChild,
  UIEvent,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react'

const shadowHeight = '30px'

const Container = styled(Box)`
  overflow: hidden;
  flex-direction: row;
  justify-content: flex-start;
`

const Shadow = styled(Box, noForwardProps)<{ __opacity: number }>`
  position: relative;
  width: 100%;
  pointer-events: none;
  height: ${shadowHeight};
  opacity: ${props => props.__opacity};
  transition-duration: ${DEFAULT_ANIMATE_DURATION}ms;
`

const TopShadow = styled(Shadow)`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.35), transparent);
  z-index: 1;
`

const BottomShadow = styled(Shadow)`
  margin-top: -${shadowHeight};
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.35), transparent);
`

const ScrollContainer = styled(ApeironScrollBox)`
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: -${shadowHeight};
  height: 100%;
`

const ShadowScroll: FC<Props> = (props: Props) => {
  const { children, className } = props

  const ref = useRef(null)

  const [atTop, setAtTop] = useState(true)

  const [atBottom, setAtBottom] = useState(true)

  const handleOnScroll = useCallback((event: UIEvent<HTMLElement>): void => {
    const target = R.prop('target', event) as Element | null

    if (target) {
      const { scrollTop, scrollHeight, clientHeight } = target as Element

      setAtTop(scrollTop === 0)

      setAtBottom(clientHeight + scrollTop >= scrollHeight - 1)
    }
  }, [])

  useEffect(() => {
    if (ref) {
      const current = ref.current as Element | null

      setAtBottom(
        current ? current.scrollHeight === current.clientHeight : true
      )
    }
  }, [ref])

  return (
    <Container className={className}>
      <TopShadow __opacity={atTop ? 0 : 1} />
      <ScrollContainer
        className='Custom-Scroll-Container'
        onScroll={handleOnScroll}
        ref={ref}
      >
        {children}
      </ScrollContainer>
      <BottomShadow __opacity={atBottom ? 0 : 1} />
    </Container>
  )
}

type Props = {
  children: ReactChild | ReactChild[]
  className?: string
}

export default ShadowScroll
